
import { Component, Vue } from 'vue-property-decorator'
import {CookieHelper, LocationHelper, RequestHelper} from '@/helpers/index'

// Component imports to globally register
import FinanceDetails from '@/components/forms/FinanceDetails.vue'
import DrivingLicense from '@/components/forms/DrivingLicense.vue'
import AmountToFinance from '@/components/forms/AmountToFinance.vue'
import DateOfBirth from '@/components/forms/DateOfBirth.vue'
import EmploymentForm from '@/components/forms/employment/EmploymentForm.vue'
import EmploymentStatus from '@/components/forms/employment/EmploymentStatus.vue'
import EmploymentDetails from '@/components/forms/employment/EmploymentDetails.vue'
import EmploymentLength from '@/components/forms/employment/EmploymentLength.vue'
import AddressForm from '@/components/forms/address/AddressForm.vue'
import AddressStatus from '@/components/forms/address/AddressStatus.vue'
import AddressDetails from '@/components/forms/address/AddressDetails.vue'
import AddressLength from '@/components/forms/address/AddressLength.vue'
import MaritalStatus from '@/components/forms/MaritalStatus.vue'
import Summary from '@/components/forms/Summary.vue'
import ContactDetails from '@/components/forms/ContactDetails.vue'
import InputGroup from '@/components/inputs/InputGroup.vue'
import InputNumeric from '@/components/inputs/InputNumeric.vue'
import InputText from '@/components/inputs/InputText.vue'
import InputDateOfBirth from '@/components/inputs/InputDateOfBirth.vue'
import Accordion from '@/components/shared/Accordion.vue'
import Tooltip from '@/components/shared/Tooltip.vue'

import AffiliateConfig from '@/types/affiliate/affiliate-config'
import { AffiliateModule, ApplicationModule, AuthModule, WizardModule } from './store'
import { AFFILIATES } from './factories'
import { AgentService, PrePopApplicationService, VehicleService, SegmentService, FeatureSwitchService } from './services'
import Modal from '@/components/shared/Modal.vue'
import PartnerRepAprModel from '@/components/shared/PartnerRepAprModel.vue'

import ModalV3 from '@/components/shared/ModalV3.vue'
import PartnerRepAprModelV3 from '@/components/shared/PartnerRepAprModelV3.vue'
import ModalMobile from '@/components/shared/ModalMobile.vue'
import PartnerRepAprModelMobile from '@/components/shared/PartnerRepAprModelMobile.vue'

import AddressDto from './types/dto/addressDto'
import EmploymentDto from './types/dto/employmentDto'
import LookupValueDto from './types/dto/lookupValueDto'
import Vidle from 'v-idle'
import WizardStep from './components/wizard/WizardStep'
import { MetaInfo } from 'vue-meta';
import { languages } from './lang'

// Globally register components to allow dynamic component loading
Vue.component('Summary', Summary)
Vue.component('FinanceDetails', FinanceDetails)
Vue.component('AmountToFinance', AmountToFinance)
Vue.component('DateOfBirth', DateOfBirth)
Vue.component('EmploymentForm', EmploymentForm)
Vue.component('EmploymentStatus', EmploymentStatus)
Vue.component('EmploymentDetails', EmploymentDetails)
Vue.component('EmploymentLength', EmploymentLength)
Vue.component('AddressForm', AddressForm)
Vue.component('AddressStatus', AddressStatus)
Vue.component('AddressDetails', AddressDetails)
Vue.component('AddressLength', AddressLength)
Vue.component('MaritalStatus', MaritalStatus)
Vue.component('DrivingLicense', DrivingLicense)
Vue.component('ContactDetails', ContactDetails)
Vue.component('InputNumeric', InputNumeric)
Vue.component('InputText', InputText)
Vue.component('InputDateOfBirth', InputDateOfBirth)
Vue.component('InputGroup', InputGroup)
Vue.component('Accordion', Accordion)
Vue.component('Tooltip', Tooltip)
Vue.component('Modal', Modal)
Vue.component('PartnerRepAprModel', PartnerRepAprModel)

Vue.component('ModalV3', ModalV3)
Vue.component('PartnerRepAprModelV3', PartnerRepAprModelV3)
Vue.component('ModalMobile', ModalMobile)
Vue.component('PartnerRepAprModelMobile', PartnerRepAprModelMobile)

Vue.use(Vidle)

	@Component({
		metaInfo(this: App) {
			const externalScripts = this.externalScripts;
			return {
				script: externalScripts,
			};
		},
	})
export default class App extends Vue {
  	// Data

		private scripts:any = [];

		showTimeoutModal = false;
		displayModal = false;
		show = true;
		theme = 'h-100';
		useModelV3 = true;

		// Hooks
		async mounted () {
		  AuthModule.updateIsIdle(false)
		  ApplicationModule.updateLockDown(false)
		  ApplicationModule.updateIsSubmitting(false)

			let appId:any = RequestHelper.getQueryVariable('appid')

			if (appId) {
				ApplicationModule.reset()
			}

			this.fetchExternalScripts();

		  this.displayModal = false

		  ApplicationModule.updateGUID()
		  AuthModule.updateIsProduction()
		  ApplicationModule.updateApplicationID()

		  // Set Host
		  let host = LocationHelper.getHost()

		  // for testing purposes pass in a host as a query string e.g. &host=oceanfinance
		  if (!AuthModule.isProduction && this.$route.query.host) {
		    host = this.$route.query.host as string
		  }

		  AffiliateModule.updateHost(host)
		  AffiliateModule.updateSubDomain(null)

		  AffiliateModule.updateAffiliateConfig({} as AffiliateConfig)

		  // Ensure host exists in our affiliates
		  if (Object.keys(AFFILIATES).includes(host)) {
		    // Get config from factory
		    const affiliateConfig = AFFILIATES[host as keyof typeof AFFILIATES] as AffiliateConfig

		    // Update store
		    AffiliateModule.updateSubDomain(host)
		    AffiliateModule.updateAffiliateConfig(affiliateConfig)

		    // Show partner modal
		    this.displayModal = !!(affiliateConfig.showPartnerModal !== null &&
					affiliateConfig.showPartnerModal)

			// use v3 model
			this.useModelV3 = !!(affiliateConfig['useModelV3'] )

				// set theme
			 if (!!(affiliateConfig.theme !== null && affiliateConfig.theme)) {
			 	this.theme = `h-100 ${affiliateConfig.theme}`;
			 }

			// set theme-color
			if (!!(affiliateConfig.themeColor !== null && affiliateConfig.themeColor)) {
				var reg=/^#([0-9a-f]{3}){1,2}$/i;
				if ( reg.test(affiliateConfig.themeColor) ) {
			 		document.querySelector('meta[name="theme-color"]')?.setAttribute('content',  affiliateConfig.themeColor);
				}
			}

			  // set lang
				const langName = host.replace("-", "_");
				const lang = languages[langName];

				if (lang) {
					this.$root.$i18n.locale = langName;
				}
		  }

		  ApplicationModule.updateUTMParameters()
		  ApplicationModule.updateQuoteId()
		  ApplicationModule.updateClickId()

		  // Set data for application
		  await this.setApplicationData();

		  (this as any).$appInsights.trackEvent({
		    name: 'Application Form - Started',
		    properties: {
		      event_category: 'Application Form',
		      event_action: 'Started',
		      event_label: ApplicationModule.GUID
		    }
		  })

			SegmentService.checkSegmentLoaded().then( () => {
				SegmentService.initSegment()
				SegmentService.trackApplicationFormStart({
					guid: ApplicationModule.GUID
				})
			})


		  ApplicationModule.updateIsLoaded(true)

			let win = window as any;
			let cookieyesNecessary = CookieHelper.get('cookieyes-necessary');

			if (cookieyesNecessary === 'yes') {
				win.clarity('consent');

				if (typeof win.symplify !== 'undefined') {
					win.symplify.optIn(1);
				} else {
					document.addEventListener("symplify-loaded", function() {
						win.symplify.optIn(1);
					});
				}
			}
		}

		closeModal () {
		  this.displayModal = false
		}

		// Called when v-idle component idle time has been hit
		onIdle () {
		  if (!this.isIdle) {
		    AuthModule.updateIsIdle(true)
		  }
		}

		// Reset stuff after a session timeout and reload the application
		async closeTimeoutModal () {
		  // refresh auth token
		  AuthModule.updateAuthToken()
		  // reset application store
		  ApplicationModule.reset()

		  this.displayModal = false
		  AuthModule.updateIsIdle(false)
		  // reget application data
		  await this.setApplicationData()
		}

		// Sets data necessary for application and gets by appid if exists
		async setApplicationData () {
		  // Hide app form, allows componetes to remount when shown again
		  this.show = false

		  ApplicationModule.updateUrlReferrer()
		  ApplicationModule.updateAppliedDate()

		  ApplicationModule.updateLoanAmount()
			ApplicationModule.updateVehicleTypeId();
		  ApplicationModule.updateVehicleOnLoad()

		  await AuthModule.updateAuthToken()
		  await AuthModule.updateIpAddress()
		  await AuthModule.updateUserAgent()

		  // Tasks that will run async
		  const tasks: Promise<void>[] = []

		  // Load Form
		  if (ApplicationModule.applicationID && AffiliateModule.affiliateConfig && AffiliateModule.affiliateConfig.prePopulateForm) {
		    tasks.push(PrePopApplicationService.prePopAppForm())
		  }

		  // Load Vehicle
		  if (ApplicationModule.vehicleID !== null && Number(ApplicationModule.vehicleID) > 0 && AffiliateModule.affiliateConfig !== null) {
		    tasks.push(VehicleService.loadVehicle())
		  }

		  // Load Agent
		  if (ApplicationModule.utmParameters && ApplicationModule.utmParameters.agentPublicId) {
		    tasks.push(AgentService.loadAgent())
		  }

		  // Await all tasks completed
		  await Promise.all(tasks)

		  // Add an initial address and employment if new application
		  if (!ApplicationModule.applicationID) {
		    ApplicationModule.updateAddress({
		      addressLevel: 0,
		      yearsAtAddress: 0,
		      monthsAtAddress: 0,
		      residentialStatusLookup: {
		        id: -1
		      } as LookupValueDto
		    } as AddressDto)

		    ApplicationModule.updateEditingEmployment({
		      employmentLevel: 0,
		      employerName: '',
		      employerTown: '',
		      occupation: '',
		      yearsAtEmployer: 0,
		      monthsAtEmployer: 0,
		      employmentStatusLookup: {
		        id: -1
		      } as LookupValueDto
		    } as EmploymentDto)
		  }

		  // Clear and reset wizard steps
		  WizardModule.updateCallback()

		  WizardModule.updateWizardSteps([])
		  WizardModule.updateWizardSteps([
		    { id: 1, name: 'Finance Details', component: 'FinanceDetails', isComplete: false, showButtons: false },
		    { id: 2, name: 'Driving License', component: 'DrivingLicense', isComplete: false, showButtons: true },
		    { id: 3, name: 'Amount To Finance', component: 'AmountToFinance', isComplete: false, showButtons: true },
		    { id: 4, name: 'Date Of Birth', component: 'DateOfBirth', isComplete: false, showButtons: true },
		    { id: 5, name: 'Address History', component: 'AddressForm', isComplete: false, showButtons: true },
		    { id: 6, name: 'Employment Details', component: 'EmploymentForm', isComplete: false, showButtons: true },
		    { id: 7, name: 'Marital Status', component: 'MaritalStatus', isComplete: false, showButtons: true },
		    { id: 8, name: 'Contact Details', component: 'ContactDetails', isComplete: false, showButtons: true },
		    { id: 9, name: 'Summary', component: 'Summary', isComplete: false, showButtons: false }
		  ] as WizardStep[])

		  this.show = true
		}

		fetchExternalScripts() {
			let isProduction = AuthModule.isProduction;

			this.externalScripts.push({ id: 'gtm', src: '/gtm.js', async: false, defer: false });

			const segmentScript = isProduction ? { id: 'segment', src: '/segment-prod.js', async: false, defer: false } : { id: 'segment', src: '/segment-dev.js', async: false, defer: false };

			this.externalScripts.push(segmentScript);

			let host = LocationHelper.getHost();

			FeatureSwitchService.isFeatureEnabled(`partner_optimize_${host}`).then((isEnabled) => {
				if (isEnabled) {
					window.console.log('anti-flicker snippet', true);
					const antiFlickerScript = { id: 'antiflicker', src: '/anti-flicker.js', async: false, defer: false }
					this.externalScripts.push(antiFlickerScript);
				} else {
					window.console.log('anti-flicker snippet', false);
				}
			});
		}

		get isIdle () {
		  return AuthModule.isIdle
		}

		get isAuthenticated () {
		  return AuthModule.token && AuthModule.token.authenticationToken
		}

		get host () {
		  return AffiliateModule.host
		}

		get isLockdown () {
		  return ApplicationModule.lockDown
		}

		get externalScripts () {
			return this.scripts;
		}
}
